module.exports = __webpack_public_path__ + "fonts/Manrope-800-greek27.4f6140c.woff2";